// Настройка для дополенний улиц с сервера
import autoText from './config';
import PerfectScrollbar from 'perfect-scrollbar';
import streetsInfo from 'lib/locations/streets';
import { clearspaces, ftrim } from 'mdlib';

/**
 * extra options {
 * 	requireData - убивает надпись если ни один пункт не выббран
 * 	cityRequired - требуется выбранный город для загрузки
 * }
 */

autoText.config.tempaltes.add(
    new autoText.config.tempaltes.Template('street', {
        loading: () =>
            `<li class="ui-inlst-item">
            Загружаем
        </li>`,
        error: (message) =>
            `<li class="ui-inlst-item">
            ${message}
        </li>`,
        empty: () =>
            `<li class="ui-inlst-item">
            Ничего не найдено
        </li>`,
        ok: (data = {}) => {
            let city = '';

            if (data.subCity) {
                city = `<p class="ui-inlst-item-subitem">${data.subCity.name}</p>`;
            }

            return `<li class="ui-inlst-item">
                    ${data.fullName || ''}
                    ${city}
                </li>`;
        },
        active: (data = {}) => {
            let city = '';

            if (data.subCity) {
                city = `<p class="ui-inlst-item-subitem">${data.subCity.name}</p>`;
            }

            return `<li class="ui-inlst-item active">
                    ${data.fullName || ''}
                    ${city}
                </li>`;
        },
    })
);

// Получение внешнего вида результата (текст)
autoText.config.results.add(
    new autoText.config.results.Template('street', (opts = {}) => {
        var streetName = opts.fullName || '';
        // if (opts.subCity) {
        //     return opts.subCity.name + ', ' + streetName;
        // }
        return streetName;
    })
);

autoText.config.loaders.add(
    new autoText.config.loaders.Loader(
        'street',
        (at, val, opts = {}, resolve, reject) => {
            if (!opts.city && opts.cityRequired) {
                reject('Город не выбран');
                return null;
            }

            const requestdata = {};

            if (val) {
                requestdata.str = val;
            }

            if (opts.city !== undefined) {
                requestdata.city = opts.city;
            }

            if (opts.paged && opts.loadingPage) {
                requestdata.page = opts.loadingPage;
            }

            const request = streetsInfo.prepareRequest(requestdata);

            request.make().then(
                (result) => {
                    if (opts.paged && (!result || !result.length)) {
                        opts.canNextPage = false;
                    }

                    resolve(result);
                },
                (e) => {
                    reject(e !== 'abort' ? 'Ошибка при загрузке' : null);
                }
            );

            return request.xhr;
        },
        (current) => {
            if (!current) {
                return;
            }

            current.abort();
        }
    )
);

autoText.config.eventsCheck
    .add(
        new autoText.config.eventsCheck.Check('street', 'close', (at) => {
            var requireData = at.options.requireData;

            // Если нет уже выбранных данных попытаемся еще раз для сопоставления с написанным
            if (!at.data()) {
                at.select();

                // Сотрем если все равно ничего не нашли
                if (requireData && !at.data()) {
                    at.val('');
                }
            }
        })
    )
    .add(
        new autoText.config.eventsCheck.Check(
            'street',
            'select',
            (at, data) => {
                var result = data;
                if (!result) {
                    const query = clearspaces(ftrim(at.val()));

                    if (query) {
                        result = at
                            .listData()
                            .find(
                                (value) =>
                                    value.name.toLowerCase() ===
                                    query.toLowerCase()
                            );
                    }
                }

                return result || null;
            }
        )
    )
    .add(
        new autoText.config.eventsCheck.Check('street', 'init', (at) => {
            var list = at.list();

            const perfectSB = new PerfectScrollbar(list.get(0));
            perfectSB.update(list.get(0));

            if (!at.options.paged) {
                return;
            }

            at.options.currentPage = 0;
            at.options.loadingPage = null;
            at.options.canNextPage = true;

            list.on('scroll', () => {
                if (!at.options.canNextPage || at.isLoading()) {
                    return;
                }

                const scrollPosition = list.scrollTop();
                const scrollHeight = list.get(0).scrollHeight;
                const innerHeight = list.innerHeight();
                const uploadHeight =
                    scrollHeight * 0.9 < 100 ? 100 : scrollHeight * 0.9;

                if (scrollPosition + innerHeight < uploadHeight) {
                    return;
                }

                at.options.loadingPage = at.options.currentPage + 1;
                at.load(false);
            });
        })
    )
    .add(
        new autoText.config.eventsCheck.Check('street', 'loaded', (at) => {
            if (!at.options.paged) {
                return undefined;
            }

            if (at.options.currentPage === 0 || !at.options.loadingPage) {
                return undefined;
            }

            return at.options.currentPage === at.options.loadingPage;
        })
    )
    .add(
        new autoText.config.eventsCheck.Check('street', 'onclear', (at) => {
            if (!at.options.paged) {
                return;
            }

            at.options.currentPage = 0;
            at.options.loadingPage = null;
            at.options.canNextPage = true;
        })
    )
    .add(
        new autoText.config.eventsCheck.Check(
            'street',
            'loadComplete',
            (at) => {
                var list = at.list();

                if (at.options.paged) {
                    at.options.currentPage = at.options.loadingPage || 1;
                }

                window.setTimeout(() => {
                    const perfectSB = new PerfectScrollbar();
                    perfectSB.update(list.get(0));
                }, 100);
            }
        )
    )
    .add(
        new autoText.config.eventsCheck.Check('street', 'afterOpen', (at) => {
            var list = at.list();

            window.setTimeout(() => {
                const perfectSB = new PerfectScrollbar();
                perfectSB.update(list.get(0));
            }, 100);
        })
    );

export default autoText;
